import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import type { TranslationKeys } from "@/hooks/useTranslation/useTranslation"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"
import type { HoldReason } from "./holdReason"
import { McPill } from "./McPill"

interface RoundtripHoldPillProps {
  reason: HoldReason
  className?: string
}

const LABEL_KEY: Record<HoldReason, TranslationKeys> = {
  blank_template: "MC_DECL_BADGE_ROUNDTRIP_HOLD",
  unfilled_form: "MC_DECL_BADGE_UNFILLED_FORM",
  other: "MC_DECL_BADGE_HOLD_OTHER",
}
const TOOLTIP_KEY: Record<HoldReason, TranslationKeys> = {
  blank_template: "MC_DECL_ROUNDTRIP_HOLD_TOOLTIP",
  unfilled_form: "MC_DECL_UNFILLED_FORM_TOOLTIP",
  other: "MC_DECL_HOLD_OTHER_TOOLTIP",
}

/** TUR-1452: a declaration the pipeline HELD: processed, nothing staged; the
 *  reason picks the label and the explanation. The short pill names the
 *  state; the full explanation lives in the Tooltip, never a native `title`
 *  (the row/detail header need more than a label). */
export function RoundtripHoldPill({
  reason,
  className,
}: RoundtripHoldPillProps) {
  const { translate } = useTranslation()

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          {/* Plain `<span>` as the trigger — `McPill` isn't `forwardRef`, and
              Radix needs a real DOM ref on the trigger to position the
              content, so it wraps `McPill` rather than taking it directly. */}
          <span
            tabIndex={0}
            className={cn("inline-flex cursor-default", className)}
          >
            <McPill tone="attention">{translate(LABEL_KEY[reason])}</McPill>
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[280px]">
          {translate(TOOLTIP_KEY[reason])}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
